// The SQLite plugin tracks native connections globally but SQLiteConnection
// tracks them per JavaScript instance. Use one instance for every offline store:
// checkConnectionsConsistency() on a second empty instance closes the first.
let managerPromise;
let opening = Promise.resolve();
const databases = new Map();

function manager() {
  if (!managerPromise) {
    managerPromise = import('@capacitor-community/sqlite').then(async ({ CapacitorSQLite, SQLiteConnection }) => {
      const sqlite = new SQLiteConnection(CapacitorSQLite);
      await sqlite.checkConnectionsConsistency();
      return sqlite;
    }).catch((error) => {
      managerPromise = undefined;
      throw error;
    });
  }
  return managerPromise;
}

export function openOfflineDatabase(name) {
  if (databases.has(name)) return databases.get(name);
  const pending = opening.then(async () => {
    const sqlite = await manager();
    const exists = await sqlite.isConnection(name, false);
    const db = exists.result
      ? await sqlite.retrieveConnection(name, false)
      : await sqlite.createConnection(name, false, 'no-encryption', 1, false);
    if (!exists.result || !(await db.isDBOpen()).result) await db.open();
    return db;
  });
  opening = pending.catch(() => {});
  databases.set(name, pending);
  pending.catch(() => { if (databases.get(name) === pending) databases.delete(name); });
  return pending;
}
